import './icon-placement-options.scss';
import { createIcon } from '@integration-frontends/common/ui/icons/create-icon';
import React from 'react';

export const IconPlacementOptions = createIcon(<div className="icon-placement-options" />);
